import React from 'react';

const OurPartners = () => {
  // Partenaires internationaux
  const internationalPartners = [
    {
      id: 1,
      name: "MIT",
      logo: "https://logos-download.com/wp-content/uploads/2021/01/Massachusetts_Institute_of_Technology_Logo.png",
      url: "#"
    },
    {
      id: 2,
      name: "Stanford",
      logo: "https://logos-download.com/wp-content/uploads/2016/10/Stanford_University_logo.png",
      url: "#"
    },
    {
      id: 3,
      name: "Sorbonne",
      logo: "https://upload.wikimedia.org/wikipedia/fr/thumb/8/8c/Logo_Sorbonne_Universit%C3%A9.svg/1200px-Logo_Sorbonne_Universit%C3%A9.svg.png",
      url: "#"
    },
    {
      id: 4,
      name: "EPFL",
      logo: "https://upload.wikimedia.org/wikipedia/fr/thumb/9/9a/Logo-epfl.svg/1200px-Logo-epfl.svg.png",
      url: "#"
    },
    {
      id: 5,
      name: "Maker's Asylum",
      logo: "https://images.squarespace-cdn.com/content/v1/53c2ebeae4b0b7c4d8556f16/1591623163567-8J7OZ6S3X3L8H5DZ0YMM/makersasylum+logo+black.png",
      url: "#"
    }
  ];

  // Partenaires locaux
  const localPartners = [
    {
      id: 1,
      name: "IrokoLab",
      logo: "https://irokolab.com/wp-content/uploads/2021/07/irokolab-logo.png",
      url: "#"
    },
    {
      id: 2,
      name: "Université Cheikh Anta Diop",
      logo: "https://www.ucad.sn/sites/default/files/logo_0.png",
      url: "#"
    },
    {
      id: 3,
      name: "African Tech Hub",
      logo: "https://images.unsplash.com/photo-1614064641938-3bbee52942c7?auto=format&fit=crop&q=80&w=400",
      url: "#"
    },
    {
      id: 4,
      name: "Tech4Dev",
      logo: "https://images.unsplash.com/photo-1560472355-536de3962603?auto=format&fit=crop&q=80&w=400",
      url: "#"
    },
    {
      id: 5,
      name: "Green Africa",
      logo: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?auto=format&fit=crop&q=80&w=400",
      url: "#"
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 px-4 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-title font-bold text-center text-dark-1 mb-4">
          Nos <span className="text-blue-1">Partenaires</span>
        </h2>
        <p className="text-center text-gray-600 text-subtitle mb-12 max-w-3xl mx-auto">
          Nous collaborons avec des institutions prestigieuses et des acteurs locaux engagés pour offrir les meilleures opportunités à nos makers.
        </p>

        {/* Partenaires internationaux */}
        <div className="mb-16">
          <h3 className="text-xl md:text-2xl font-semibold text-center text-dark-1 mb-8">
            Partenaires <span className="text-blue-500">Internationaux</span>
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
            {internationalPartners.map(partner => (
              <div
                key={partner.id}
                className="bg-white rounded-xl p-4 md:p-6 flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-12 md:h-16 object-contain max-w-full"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Partenaires locaux */}
        <div>
          <h3 className="text-xl md:text-2xl font-semibold text-center text-dark-1 mb-8">
            Partenaires <span className="text-green-500">Locaux</span>
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
            {localPartners.map(partner => (
              <div
                key={partner.id}
                className="bg-white rounded-xl p-4 md:p-6 flex items-center justify-center shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-12 md:h-16 object-contain max-w-full"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Call-to-action */}
        <div className="text-center mt-16">
          <p className="text-gray-600 mb-6">Vous souhaitez devenir partenaire ?</p>
          <a href="/contact">
            <button className="bg-red-4 hover:bg-white text-white hover:text-red-4 py-3 px-8 rounded-full
          transition-colors duration-300 inline-flex items-center border-2 border-red-4 text-button">
              Nous contacter
              <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default OurPartners;